import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { NavBarMaterial, NavBarObject, NavBarScene } from '@sloyd/ui';
import { useMemo } from 'react';
import { $a } from 'shared-base';

export type ObjectBarContainerProps = {};

export function ObjectBarContainer(props: ObjectBarContainerProps) {
  const dispatch = useDispatch();
  const objectBar = useSelector(selectors.bars.$objectBar);
  const editMode = useSelector(selectors.base.$editMode);
  const focusMode = useSelector(selectors.base.$focusMode);
  const projectType = useSelector(selectors.single.$projectType);

  const Cmp = useMemo(() => {
    switch (editMode) {
      case 'object':
        return NavBarObject;
      case 'material':
        return NavBarMaterial;
      case 'scene':
      case 'live':
        return NavBarScene;
      default:
        return null;
    }
  }, [editMode]);

  const callbacks = useMemo(
    () => ({
      onNavigate: (path: string) => {
        dispatch($a('EDITOR', 'navigate', '', { path }));
      },
      onAction: (action: Action) => {
        dispatch(action);
      },
      onResize: (width: number) => {
        dispatch($a('EDITOR', 'resizeNavBar', '', { width }));
      },
    }),
    []
  );

  if (!Cmp || focusMode === 'none' || focusMode === 'spawn') {
    if (projectType !== 'scene') {
      return null;
    }
  }

  return <Cmp data={objectBar} callbacks={callbacks} />;
}
